export const baseResources = Object.freeze({
    // User Access & Roles
    USER_MANAGEMENT_USERS: "USER_MANAGEMENT_USERS",
    USER_MANAGEMENT_ROLES: "USER_MANAGEMENT_ROLES",
    WORKSPACE_PROFILE: "WORKSPACE_PROFILE",

    // Content & Structure Management
    KB_CLASS: "KB_CLASS",
    KB_CLASS_ATTACHMENT: "KB_CLASS_ATTACHMENT",
    KB_CLASS_FORMAT: "KB_CLASS_FORMAT",
    KB_CAPSULE_SETTINGS: "KB_CAPSULE_SETTINGS",

    // Knowledge Base Management & Documentation
    KB_PRODUCT_SETTING: "KB_PRODUCT_SETTING",
    KB_CAPSULE: "KB_CAPSULE",
    KB_CONTENT_BLOCK: "KB_CONTENT_BLOCK",
    KB_SAM_COLLECTION: "KB_SAM_COLLECTION",
    KB_KNOWLEDGE_BASE: "KB_KNOWLEDGE_BASE",

    // Forms
    KB_FORM_SETTING: "KB_FORM_SETTING",
    KB_FORM_CONTENT: "KB_FORM_CONTENT",
    KB_FORM_ITEM: "KB_FORM_ITEM",

    // Post-Forms
    KB_POST_FORM: "KB_POST_FORM",
    KB_POST_FORM_WORKFLOW: "KB_POST_FORM_WORKFLOW",

    // Canned Responses
    KB_CANNED_RESPONSE: "KB_CANNED_RESPONSE",

    // Ticket Routing
    TICKET_CLASSIFICATION: "TICKET_CLASSIFICATION",
    AGENTS_INBOX_TEAM: "AGENTS_INBOX_TEAM",
    AGENTS_INBOX_TEAM_MEMBER: "AGENTS_INBOX_TEAM_MEMBER",
    TICKET_ROUTING: "TICKET_ROUTING",
    AGENTS_INBOX_BASE_SETTING: "AGENTS_INBOX_BASE_SETTING",

    // Integrations
    INTEGRATION_GMAIL: "INTEGRATION_GMAIL",

    // Ticket Management
    AGENTS_INBOX: "AGENTS_INBOX",
    TICKET_FILTER_EMAIL: "TICKET_FILTER_EMAIL",
    TICKET_FILTER_AGENT: "TICKET_FILTER_AGENT",
    TICKET_THIRD_PARTY_EMAIL: "TICKET_THIRD_PARTY_EMAIL",
    TICKET_MENTION: "TICKET_MENTION",
    TICKET_CANNED_RESPONSE_SEND: "TICKET_CANNED_RESPONSE_SEND",
    TICKET_POST_FORM_SEND: "TICKET_POST_FORM_SEND",
    TICKET_AGENT_ASSISTANT: "TICKET_AGENT_ASSISTANT",
    TICKET_SNOOZE: "TICKET_SNOOZE",
    TICKET_READ_STATUS: "TICKET_READ_STATUS",
    TICKET_CLOSE: "TICKET_CLOSE",
    TICKET_ATTACHMENT: "TICKET_ATTACHMENT",

    // Follow-Ups
    FOLLOW_UP: "FOLLOW_UP",
    FOLLOW_UP_COLLECTION: "FOLLOW_UP_COLLECTION",

    // Workflow Settings & Configurations
    KB_SAM_ISSUE_CONVERSATION: "KB_SAM_ISSUE_CONVERSATION",
    KB_CONVERSATION_PIN: "KB_CONVERSATION_PIN",
    KB_CONVERSATION_LIBRARY: "KB_CONVERSATION_LIBRARY",

    // Agent Guides
    KB_AGENT_GUIDE: "KB_AGENT_GUIDE",
    KB_AGENT_GUIDE_SCENARIO: "KB_AGENT_GUIDE_SCENARIO",
    KB_AGENT_GUIDE_EMAIL_UPDATE: "KB_AGENT_GUIDE_EMAIL_UPDATE",
    KB_AGENT_GUIDE_RESPONSE_UPDATE: "KB_AGENT_GUIDE_RESPONSE_UPDATE",
    KB_AGENT_GUIDE_MENTION_UPDATE: "KB_AGENT_GUIDE_MENTION_UPDATE",

    // LLM Documentation
    KB_LLM_DOCUMENT: "KB_LLM_DOCUMENT",
    KB_LLM_CHAT: "KB_LLM_CHAT",

    // Dependency
    KB_DEPENDENCY: "KB_DEPENDENCY",
    KB_DEPENDENCY_TOGGLE: "KB_DEPENDENCY_TOGGLE",
    KB_SAM_BRANCH: "KB_SAM_BRANCH",
    KB_DOWNTIME_COLLECTION: "KB_DOWNTIME_COLLECTION",

    // Service Module
    AGENTS_INBOX_SERVICE_SETTING: "AGENTS_INBOX_SERVICE_SETTING",
    AGENTS_INBOX_PERSONA: "AGENTS_INBOX_PERSONA",
    AGENTS_INBOX_CONVERSATION_BREAKER: "AGENTS_INBOX_CONVERSATION_BREAKER",
    AGENTS_INBOX_CONVERSATION_BREAKER_OPTION:
        "AGENTS_INBOX_CONVERSATION_BREAKER_OPTION",
    AGENTS_INBOX_REMINDER: "AGENTS_INBOX_REMINDER",

    // Analytics
    ANALYTICS: "ANALYTICS",
});

export const baseResourceActions = Object.freeze({
    CREATE: "CREATE",
    READ: "READ",
    UPDATE: "UPDATE",
    DELETE: "DELETE",
});

export const permissionTypes = baseResourceActions;

export const permissionGroups = Object.freeze({
    USER_ACCESS_ROLES: "USER_ACCESS_ROLES",
    CONTENT_STRUCTURE_MANAGEMENT: "CONTENT_STRUCTURE_MANAGEMENT",
    KNOWLEDGE_BASE_MANAGEMENT: "KNOWLEDGE_BASE_MANAGEMENT",
    FORMS: "FORMS",
    POST_FORMS: "POST_FORMS",
    CANNED_RESPONSES: "CANNED_RESPONSES",
    TICKET_ROUTING: "TICKET_ROUTING",
    INTEGRATIONS: "INTEGRATIONS",
    TICKET_MANAGEMENT: "TICKET_MANAGEMENT",
    FOLLOW_UPS: "FOLLOW_UPS",
    WORKFLOW_SETTINGS: "WORKFLOW_SETTINGS",
    AGENT_GUIDES: "AGENT_GUIDES",
    LLM_DOCUMENTATION: "LLM_DOCUMENTATION",
    DEPENDENCY: "DEPENDENCY",
    SERVICE_MODULE: "SERVICE_MODULE",
    ANALYTICS: "ANALYTICS",
});

// No system permission is implicitly granted to every authenticated user
// anymore (the previous READ_PROFILE shortcut is no longer seeded).
export const defaultPermissions = [];

export const pathTypes = Object.freeze({
    SINGLE: "SINGLE",
    TABBED: "TABBED",
    DROPDOWN: "DROPDOWN",
});
